import { render, staticRenderFns } from "./CreateProfileForm.vue?vue&type=template&id=00b2c879&scoped=true"
import script from "./CreateProfileForm.vue?vue&type=script&lang=js"
export * from "./CreateProfileForm.vue?vue&type=script&lang=js"
import style0 from "./CreateProfileForm.vue?vue&type=style&index=0&id=00b2c879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2c879",
  null
  
)

export default component.exports